<!-- 
  -- Component shows a date picker with additional previous, next day and today button
  -- v-model is the date (Date object!)
-->
<template>
  <div class="d-flex align-center" style="border-radius: 20px">
    <v-btn class="mx-2" small @click="selectPrevious" icon>
      <v-icon :color="color">mdi-chevron-left</v-icon>
    </v-btn>

    <v-menu
      :color="color"
      v-model="isDatePickerOpen"
      :close-on-content-click="false"
      transition="scale-transition"
      offset-y
      min-width="auto"
      max-width="290"
      z-index="11000"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn text :color="color" :elevation="0" :width="110" prepend-inner-icon="mdi-calendar" v-bind="attrs" v-on="on">{{ localeFormattedDate }} </v-btn>
      </template>
      <v-date-picker
        v-model="datePickerModelYYYYMMDD"
        color="primary"
        first-day-of-week="1"
        show-week
        show-adjacent-months
        @change="onDateSelected"
      ></v-date-picker>
    </v-menu>

    <v-btn class="mx-2" small @click="selectNext" icon>
      <v-icon :color="color">mdi-chevron-right</v-icon>
    </v-btn>
    <v-btn v-if="showToday" class="mx-3" small :elevation="0" :color="color" @click="selectToday">{{ $t('today') }}</v-btn>
  </div>
</template>

<script>
import commonMixin from '@/mixins/common';
import dateUtils from '@/common/dateUtils';
import { DAY_IN_MS } from '@/common/constants';

export default {
  name: 'DateListPicker',
  props: {
    value: Date, // v-model
    color: String,
    showToday: { type: Boolean, default: true },
  },
  mixins: [commonMixin],

  data() {
    return {
      datePickerModelYYYYMMDD: null,
      isDatePickerOpen: false,
    };
  },
  mounted() {
    this.datePickerModelYYYYMMDD = dateUtils.reformatDateIsoStringAsYYYYMMDD(this.value.toISOString());
  },
  computed: {
    localeFormattedDate() {
      if (!this.datePickerModelYYYYMMDD) return '';
      let date = dateUtils.parseYYYYMMDD(this.datePickerModelYYYYMMDD);
      return dateUtils.formatAsLocaleNamedShortDate(date);
    },
  },
  methods: {
    selectPrevious() {
      let date = dateUtils.parseYYYYMMDD(this.datePickerModelYYYYMMDD);
      let previousDay = new Date(date.getTime() - DAY_IN_MS);
      this.handleDateChange(previousDay);
    },
    selectNext() {
      console.debug('selectNext', 'datePickerModelYYYYMMDD', this.datePickerModelYYYYMMDD);

      let date = dateUtils.parseYYYYMMDD(this.datePickerModelYYYYMMDD);
      console.debug('date', date);

      let nextDay = new Date(date.getTime() + DAY_IN_MS);
      console.debug('nextDay', nextDay);

      this.handleDateChange(nextDay);
    },
    selectToday() {
      let date = new Date();
      this.handleDateChange(date);
    },
    handleDateChange(date) {
      this.datePickerModelYYYYMMDD = dateUtils.formatDateAsYYYYMMDD(date);
      console.debug('handleDateChange', this.datePickerModelYYYYMMDD);
      this.$emit('input', date);
    },
    onDateSelected() {
      let date = dateUtils.parseYYYYMMDD(this.datePickerModelYYYYMMDD);
      this.isDatePickerOpen = false;
      this.$emit('input', date);
    },
  },
  watch: {
    value(newValue, oldValue) {
      this.datePickerModelYYYYMMDD = dateUtils.reformatDateIsoStringAsYYYYMMDD(newValue.toISOString());
    },
  },
};
</script>
